export async function getCoords() {
  try {
    const position: GeolocationPosition = await new Promise(
      (resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      },
    );

    return {
      long: position.coords.longitude,
      lat: position.coords.latitude,
    };
  } catch (error) {
    return null;
  }
}

export default async function (): Promise<boolean> {
  const { $debug } = useNuxtApp();

  try {
    const { isAuthenticated } = storeToRefs(useAuthStore());
    const { isNewUserToValidate } = useUserData();

    const { isGeoLocationVisitorEnabled } = useFeatureFlagsJson();
    const { getValidationModule } = useModulesValidation();

    if (!isAuthenticated.value && !isGeoLocationVisitorEnabled.value) {
      return true;
    }

    const globalModule = getValidationModule('global');

    if (
      !globalModule.length ||
      !globalModule.includes('gps' as unknown as Containment.Validation)
    ) {
      return true;
    }

    if (isAuthenticated.value && !isNewUserToValidate.value) {
      if ($debug.isEnabled) {
        console.groupCollapsed('🗺️ ~ GPS VALIDATION:\n');
        console.debug('🗺️ ~ isNewUserToValidate:', isNewUserToValidate.value);
        coloredDebug(true);
        console.groupEnd();
      }

      return true;
    }

    if (!navigator.permissions || !navigator.geolocation) {
      throw new Error('gps containment: browser not supported');
    }

    const { state } = await navigator.permissions.query({
      name: 'geolocation',
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ GPS VALIDATION:\n');
      console.debug('🗺️ ~ geolocation state:', state);
      console.groupEnd();
    }

    if (state === 'granted') {
      coloredDebug(true);
      console.groupEnd();

      return true;
    }

    const coords = await getCoords();
    const isValid = !!coords;

    if ($debug.isEnabled) {
      console.debug('🗺️ ~ geolocation coords:', coords);
      coloredDebug(isValid);
      console.groupEnd();
    }

    return isValid;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ GPS VALIDATION:\n');
      console.error(err);
      coloredDebug(false);
      console.groupEnd();
    }

    return false;
  }
}
